import { Location } from '@angular/common';
import {
  AfterViewChecked,
  Component,
  computed,
  effect,
  inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, switchMap, take } from 'rxjs';
import { OriginsEnum } from './configuration/enums/origins.enum';
import { SplitIoService } from './configuration/services/split-io.service';
import { TooltipService } from './configuration/services/tooltip.service';
import { DeviceInfoService } from './services/device-info.service';
import { InstallmentsService } from './services/installments.service';
import { OfferService } from './services/offers.service';
import { selectConfigOrigin } from './store/states/config/config.selectors';
import { selectSessionClient } from './store/states/session/session.selectors';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit, AfterViewChecked {
  @ViewChild('drawer') drawer!: MatSidenav;
  title = 'flexpag-whitelabel-checkout';
  private deviceInfo = inject(DeviceInfoService);
  private store = inject(Store);
  private OfferService = inject(OfferService);
  private installmentsService = inject(InstallmentsService);
  private splitIoService = inject(SplitIoService);
  private readonly origin = this.store.selectSignal(selectConfigOrigin);
  private readonly isOriginSerasa = computed(
    () => this.origin() === OriginsEnum.MINHAS_CONTAS || this.origin() === OriginsEnum.LNO
  );

  constructor(
    private tooltipService: TooltipService,
    private router: Router,
    private location: Location
  ) {
    effect(() =>
      this.installmentsService.drawerState() ? this.drawer.open() : this.drawer?.close()
    );
    this.store
      .select(selectSessionClient)
      .pipe(
        filter(() => !this.isOriginSerasa()),
        filter((client) => !!(client.ni || client.identityNumber)),
        take(1),
        switchMap((client) => this.OfferService.getFeatures(client.ni ?? client.identityNumber))
      )
      .subscribe();

    this.splitIoService.setDefaultFeaturesFlags();
  }

  backdropClick() {
    this.installmentsService.toggleDrawer();
  }

  ngOnInit(): void {
    console.log('version: 8.3.3');
    this.clearSessionStorage();
    this.deviceInfo.getIPAddress().subscribe();
  }

  ngAfterViewChecked(): void {
    this.tooltipService.initializeTooltips();
  }

  /**
   * Limpa dados do sessionStorage do Minha Carteira na Inicialização da aplicação
   */
  clearSessionStorage() {
    const keysToRemove = ['UF', 'debt_source', 'form', 'principalType'];
    keysToRemove.forEach((key) => sessionStorage.removeItem(key));
  }
}
